import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createContext } from 'react';
var menuDefaultState = {
  isRoot: true,
  hasIcons: false,
  hasSelectableItems: false,
  size: null,
  items: [],
  requestCloseRoot: function requestCloseRoot() {}
};
function menuReducer(state, action) {
  switch (action.type) {
    case 'enableIcons':
      return _objectSpread(_objectSpread({}, state), {}, {
        hasIcons: true
      });
    case 'enableSelectableItems':
      return _objectSpread(_objectSpread({}, state), {}, {
        hasSelectableItems: true
      });
    case 'registerItem':
      return _objectSpread(_objectSpread({}, state), {}, {
        items: [].concat(_toConsumableArray(state.items), [action.payload]).filter(function (item) {
          return item.ref.current !== null;
        })
      });
  }
}
var MenuContext = /*#__PURE__*/createContext({
  state: menuDefaultState,
  // 'dispatch' is populated by the root menu
  dispatch: function dispatch(_) {}
});
export { MenuContext, menuReducer };